import { Store } from '@/store/mainStore';
import EngineModule from '@/store/engine/modules/EngineModule';
import { BiometricService } from '@/store/engine/openapi/generated';

export default class BiometricModule extends EngineModule {
	private readonly defaultEncoding: 'draco' = 'draco';

	constructor(s: Store) {
		super(s);
	}

	public async getScans(sessionID = this.store.biometric.lastValidScanningSessionID) {
		const res = await BiometricService.biometricControllerGetScans(sessionID);
		if (!res) throw new Error('No scans returned');
		return this.nonNullableArray(res);
	}

	public async get3DScanSurfaceModel(scanID?: string, encoding = this.defaultEncoding) {
		if (!scanID) {
			return undefined;
		}
		const res = await BiometricService.biometricControllerGet3DScanSurfaceModel(scanID, encoding);
		if (!res) throw new Error('No model returned');
		return res;
	}

	public async get3DScanProperties(scanID?: string) {
		if (!scanID) {
			return undefined;
		}
		const res = await BiometricService.biometricControllerGet3DScanProperties(scanID);
		if (!res) throw new Error('No properties returned');
		return res;
	}
}
